<template>
  <div class="edit-page">
    <div class="ml-l pl-l mb-l pb-l">
      <el-button @click="$router.back()" size="small">返回</el-button>
    </div>
    <el-form :model="form" :rules="rules" label-width="120px" ref="form" size="small">
      <div class="container">
        <h3 class="title">基本信息</h3>
        <!-- 商品名称 -->
        <el-form-item label="商品名">
          <el-col span="6">
            <el-input v-model="form.name"></el-input>
          </el-col>
        </el-form-item>
        <!-- 商品描述 -->
        <el-form-item label="商品描述">
          <el-col span="12">
            <el-input v-model="form.description"></el-input>
          </el-col>
        </el-form-item>
        <!-- 添加商品图 -->
        <el-form-item label="添加商品图">
          <upload-file :limit="10" accept="image/*" v-model="form.imagesList"></upload-file>
          <div class="tips">建议尺寸：800*800像素，最多上传10张</div>
        </el-form-item>
        <el-form-item label="商品详情">
          <upload-file :limit="10" accept="image/*" v-model="form.descriptionimagesList"></upload-file>
          <div class="tips upload">上传商品详情页图片，帮助买家进一步了解商品。</div>
          <div class="tips nopt">建议图片宽度不大于1500px，质量不大于2M，最多可上传10张。</div>
        </el-form-item>
        <!-- 选择商品分类 -->
        <el-form-item label="选择分类">
          <el-row>
            <el-col :span="6">
              <el-select placeholder="请选择分类" v-model="form.categoryidlistList" multiple>
                <el-option :key="category.id" :label="category.name.slice(1).split('/')[0]" :value="category.id" v-for="category in categories"></el-option>
              </el-select>
            </el-col>
            <el-col :span="2" style="margin-left: 15px;">
              <el-button @click="$router.push({ name: 'category' })" size="small" type="text">新建类目</el-button>
            </el-col>
          </el-row>
        </el-form-item>
      </div>
      <div class="container">
        <h3 class="title">价格</h3>

        <el-form-item class="form-item-price" label="商品价格" v-show="!form.optionsDetail.length">
          <el-col span="4">
            <el-input v-model="form.price">
              <template slot="append"
                >元</template
              >
            </el-input>
          </el-col>
        </el-form-item>

        <el-form-item class="form-item-price" label="折扣价格" v-show="!form.optionsDetail.length">
          <el-row>
            <el-col span="4">
              <el-input v-model="form.discountprice">
                <template slot="append"
                  >元</template
                >
              </el-input>
            </el-col>
          </el-row>
          <div class="tips">设置该商品的折扣价格, 不填或填0代表不设置折扣价。</div>
        </el-form-item>

        <el-form-item class="form-item-price" label="会员价格" v-show="!form.optionsDetail.length">
          <el-row>
            <el-col span="4">
              <el-input v-model="form.vipprice">
                <template slot="append"
                  >元</template
                >
              </el-input>
            </el-col>
          </el-row>
          <div class="tips">设置该商品会员享有的价格, 不填或填0代表不设置会员价。</div>
        </el-form-item>

        <el-form-item label="成团人数">
          <el-row>
            <el-col span="4">
              <el-select v-model="form.groupuserquantity">
                <el-option :label="'不选择团购人数'" :value="0"></el-option>
                <el-option :label="'2人'" :value="2"></el-option>
                <el-option :label="'3人'" :value="3"></el-option>
                <el-option :label="'4人'" :value="4"></el-option>
                <el-option :label="'5人'" :value="5"></el-option>
              </el-select>
            </el-col>
          </el-row>
          <div class="tips">如不支持团购则不选择</div>
        </el-form-item>

        <el-form-item class="form-item-price" label="团购价格" v-show="!(form.optionsDetail.length || form.groupuserquantity == 0)">
          <el-row>
            <el-col span="4">
              <el-input v-model="form.groupprice">
                <template slot="append"
                  >元</template
                >
              </el-input>
            </el-col>
          </el-row>
        </el-form-item>

        <el-form-item label="商品编码">
          <el-row>
            <el-col span="4">
              <el-input v-model="form.number"></el-input>
            </el-col>
          </el-row>
          <div class="tips">如无则不填</div>
        </el-form-item>

        <el-form-item label="基准销量" v-if="showHidden">
          <el-row>
            <el-col span="4">
              <el-input v-model="form.basesalesvolume"></el-input>
            </el-col>
          </el-row>
          <div class="tips">前端销量会叠加此值</div>
        </el-form-item>

        <el-form-item class="form-item-price" label="成本价格" prop="costprice" v-show="!form.optionsDetail.length">
          <el-row>
            <el-col span="4">
              <el-input v-model="form.costprice">
                <template slot="append"
                  >元</template
                >
              </el-input>
            </el-col>
          </el-row>
          <div class="tips">成本价将用于利润统计，方便您了解经营收益。</div>
        </el-form-item>

        <el-form-item prop="online">
          <el-col span="5">
            <el-switch :active-text="'上架商品'" v-model="form.online" :active-value="1" :inactive-value="0" />
          </el-col>
          <el-col span="18">
            <div class="tips" style="margin-left: 5px; margin-top: 5px;" v-if="form.online === 0">当前商品已下架。</div>
            <div class="tips" style="margin-left: 5px; margin-top: 5px;" v-else>当前商品已上架。</div>
          </el-col>
        </el-form-item>
      </div>
    </el-form>
    <div style="height: 100px;"></div>
    <div class="buttons">
      <el-button @click="onSubmit" type="primary">发布</el-button>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import uploadFile from '../../../components/uploadFile/index.vue';
import { M } from '../../../service/grpc.js';
import { rpc } from '../../../service/index.js';
import { getToken, sortObject } from '../../../service/helper.js';
import { getCachedStore } from '../../../router/auth';

export default {
  components: {
    'upload-file': uploadFile,
  },
  data() {
    return {
      showHidden: false,
      showProDialog: false,
      categories: [],
      display: true,
      form: {
        name: '',
        categoryid: '',
        videoimage: '',
        video: '',
        imagesList: [],
        description: '',
        descriptionimagesList: [],
        supportgroup: 0,
        groupuserquantity: 0,
        quantity: 0,
        price: 0,
        discountprice: 0,
        groupprice: 0,
        withoption: 0,
        optionsList: [],
        online: 1,
        number: '',
        costprice: 0,
        withquantity: 2,
        productdescriptionlong: '',
        productnoticelistList: [],
        supportreserve: 1,
        vipprice: 0,
        withtimeslot: 1,
        basesalesvolume: 0,
        producttimeslotlistList: [
          // {
          //     weeklistList: [0],
          //     producttimeslotpricelistList: [{}],
          // },
        ],

        options: [],
        optionsDetail: []
      },
      token: '',
    };
  },
  watch: {
    'form.options': {
      deep: true,
      handler() {
        this.form.optionsDetail = this.buildOptionJson(this.form.options);
      }
    }
  },
  async created() {
    this.showHidden = localStorage.getItem("showHidden") == "true";
    this.token = getToken();
    var store = await getCachedStore();

    if (this.$route.query.type === 'edit') {
      rpc(
        'StoreProductService.GetProduct',
        M('IDWithTokenRequest', {
          token: M('Token', { token: this.token }),
          id: this.$route.query.id
        })
      ).then(res => {
        this.form = this.backend2frontend(res);

        this.form.price = this.$amount1(this.form.price);
        this.form.discountprice = this.$amount1(this.form.discountprice);
        this.form.groupprice = this.$amount1(this.form.groupprice);
        this.form.costprice = this.$amount1(this.form.costprice);
        this.form.vipprice = this.$amount1(this.form.vipprice);
        this.form.optionsDetail = this.form.optionsDetail.map(item => ({
          ...item,
          price: this.$amount1(item.price),
          discountprice: this.$amount1(item.discountprice),
          groupprice: this.$amount1(item.groupprice),
          costprice: this.$amount1(item.costprice),
          vipprice: this.$amount1(item.vipprice)
        }));
      });
    }
    rpc(
      'StoreCategoryService.GetCategoryList',
      M('CategoryListQueryRequest', {
        token: M('Token', { token: this.token }),
        ishidden: 2,
        level: 1,
        count: 100,
        sortby: 1
      })
    ).then(res => {
      this.categories = res.categorylistList;
    });
  },
  methods: {
    getDetailDesc(key) {
      if (key === 'discountprice') return '优惠价格, 不填或填0代表不设置折扣价';
      if (key === 'groupprice') return '如不支持团购则不填';
      return '';
    },
    onSubmit() {
      this.$refs.form.validate(status => {
        if (!status) return;
        let opt = JSON.parse(JSON.stringify(this.form));
        opt.price = this.$amount2(opt.price);
        opt.discountprice = this.$amount2(opt.discountprice);
        opt.groupprice = this.$amount2(opt.groupprice);
        opt.costprice = this.$amount2(opt.costprice);
        opt.vipprice = this.$amount2(opt.vipprice);
        opt.optionsDetail = opt.optionsDetail.map(item => ({
          ...item,
          price: this.$amount2(item.price),
          discountprice: this.$amount2(item.discountprice),
          groupprice: this.$amount2(item.groupprice),
          costprice: this.$amount2(item.costprice),
          vipprice: this.$amount2(item.vipprice)
        }));
        opt = this.frontend2backend(opt);

        if (!opt.categoryidlistList.length) {
          this.$message({
            message: '忘记选择分类了',
            type: 'error'
          });
          return;
        }
        // 兼容categoryid, 后期小程序端改为取categoryidlistList字段时, 即可去掉此兼容代码
        opt.categoryid = opt.categoryidlistList[0];

        // 检查价格
        if (opt.withoption == 0) {
          if (opt.price == 0) {
            this.$message({
              message: '忘记设置原价了',
              type: 'error'
            });
            return;
          }
          if (opt.discountprice != 0 && opt.discountprice >= opt.price) {
            this.$message({
              message: '如果设置折扣价, 则折扣价需小于原价',
              type: 'error'
            });
            return;
          }
          if (opt.vipprice != 0) {
            if (opt.vipprice >= opt.price) {
              this.$message({
                message: '如果设置会员价, 则会员价需小于原价',
                type: 'error'
              });
              return;
            }
            if (opt.discountprice != 0 && opt.vipprice >= opt.discountprice) {
              this.$message({
                message: '会员价应该小于折扣价',
                type: 'error'
              });
              return;
            }
          }
          if (opt.supportgroup == 1) {
            if (opt.groupprice == 0) {
              this.$message({
                message: '忘记设置团购价了',
                type: 'error'
              });
              return;
            }
            if (opt.groupprice >= opt.price) {
              this.$message({
                message: '团购价需小于原价',
                type: 'error'
              });
              return;
            }
            if (opt.discountprice != 0 && opt.groupprice >= opt.discountprice) {
              this.$message({
                message: '团购价需小于折扣价',
                type: 'error'
              });
              return;
            }
            if (opt.vipprice != 0 && opt.groupprice >= opt.vipprice) {
              this.$message({
                message: '团购价需小于会员价',
                type: 'error'
              });
              return;
            }
          }
        }
        if (opt.withoption == 1) {
          for (const itemmsg of opt.optionsList) {
            const item = itemmsg.toObject();
            if (item.price == 0) {
              this.$message({
                message: '忘记设置原价了',
                type: 'error'
              });
              return;
            }
            if (item.discountprice != 0 && item.discountprice >= item.price) {
              this.$message({
                message: '如果设置折扣价, 则折扣价需小于原价',
                type: 'error'
              });
              return;
            }
            if (item.vipprice != 0) {
              if (item.vipprice >= item.price) {
                this.$message({
                  message: '如果设置会员价, 则会员价需小于原价',
                  type: 'error'
                });
                return;
              }
              if (item.discountprice != 0 && item.vipprice >= item.discountprice) {
                this.$message({
                  message: '会员价应该小于折扣价',
                  type: 'error'
                });
                return;
              }
            }
            if (opt.supportgroup == 1) {
              if (item.groupprice == 0) {
                this.$message({
                  message: '忘记设置团购价了',
                  type: 'error'
                });
                return;
              }
              if (item.groupprice >= item.price) {
                this.$message({
                  message: '团购价需小于原价',
                  type: 'error'
                });
                return;
              }
              if (item.discountprice != 0 && item.groupprice >= item.discountprice) {
                this.$message({
                  message: '团购价需小于折扣价',
                  type: 'error'
                });
                return;
              }
              if (item.vipprice != 0 && item.groupprice >= item.vipprice) {
                this.$message({
                  message: '团购价需小于会员价',
                  type: 'error'
                });
                return;
              }
            }
          }
        }
        if (this.$route.query.type === 'edit') {
          rpc(
            'StoreProductService.UpdateProduct',
            M('ProductWithTokenRequest', {
              token: M('Token', { token: this.token }),
              product: M('Product', opt)
            })
          ).then(res => {
            this.$message({
              message: '商品保存成功',
              type: 'success'
            });
          });
          return;
        }

        rpc(
          'StoreProductService.CreateProduct',
          M('ProductWithTokenRequest', {
            token: M('Token', { token: this.token }),
            product: M('Product', opt)
          })
        ).then(res => {
          this.$router.back();
        });
      });
    },

    // 将后端的product变成前端的product, 主要是多规格才搞的这个方法
    backend2frontend(product) {
      var options = [];
      var optionsDetail = [];
      var nv = {};
      for (var i = 0; i < product.optionsList.length; i++) {
        var tmp2 = {
          price: product.optionsList[i].price,
          discountprice: product.optionsList[i].discountprice,
          groupprice: product.optionsList[i].groupprice,
          costprice: product.optionsList[i].costprice,
          vipprice: product.optionsList[i].vipprice,
          quantity: product.optionsList[i].quantity
        };
        var tmp1 = JSON.parse(product.optionsList[i].name);
        for (var k in tmp1) {
          if (!nv.hasOwnProperty(k)) {
            nv[k] = [];
          }
          if (nv[k].indexOf(tmp1[k]) === -1) {
            nv[k].push(tmp1[k]);
          }
          tmp2[k] = tmp1[k];
        }
        optionsDetail.push(tmp2);
      }
      product.optionsDetail = optionsDetail;
      for (var k in nv) {
        options.push({
          vid: k,
          name: k,
          value: nv[k].map(v => {
            return {
              vid: k + ':' + v,
              value: v
            };
          })
        });
      }
      product.options = options;
      return product;
    },

    // 将前端的product变成后端的product, 主要是多规格才搞的这个方法
    frontend2backend(product) {
      product.supportgroup = product.groupuserquantity > 0 ? 1 : 0;
      product.withoption = 0;
      product.optionsList = [];
      if (product.optionsDetail.length) {
        product.withoption = 1;
        product.optionsList = product.optionsDetail.map(v => {
          var op = {};
          var tmp = {};
          for (var k in v) {
            if (k === 'price') {
              op[k] = v[k];
              continue;
            }
            if (k === 'discountprice') {
              op[k] = v[k];
              continue;
            }
            if (k === 'vipprice') {
              op[k] = v[k];
              continue;
            }
            if (k === 'groupprice') {
              op[k] = v[k];
              continue;
            }
            if (k === 'quantity') {
              op[k] = v[k];
              continue;
            }
            if (k === 'costprice') {
              op[k] = v[k];
              continue;
            }
            tmp[k] = v[k];
          }
          op.name = JSON.stringify(sortObject(tmp));
          console.log(op);
          return M('Option', op);
        });
      }
      product.productnoticelistList = product.productnoticelistList.map(item => M('ProductNotice', item));
      product.producttimeslotlistList = product.producttimeslotlistList.map(item =>
        M('ProductTimeSlot', {
          weeklistList: item.weeklistList,
          producttimeslotpricelistList: item.producttimeslotpricelistList.map(item1 => M('ProductTimeSlotPrice', item1))
        })
      );
      return product;
    },
    getTitle(k) {
      const map = {
        firstValue: '-',
        secondValue: '-',
        thirdValue: '-',
        price: '价格（元）',
        discountprice: '折扣价（元）',
        vipprice: '会员价（元）',
        groupprice: '团购价（元）',
        quantity: '库存',
        costprice: '成本价（元）'
      };
      return map[k] ? map[k] : k;
    },
    getTitleInfo(k) {
      const map = {
        price: '原价',
        discountprice: '当有折扣价时，商品优先显示折扣价，原件则作为划线价展示, 不填或填0代表不设置折扣价',
        vipprice: '当有会员价时，会员会使用会员价, 不填或填0代表不设置会员价',
        groupprice: '拼团使用的价格',
        quantity: '商品库存',
        costprice: '用于统计商店利润'
      };
      return map[k];
    },
    removeOption(index) {
      this.form.options.splice(index, 1);
    },
    addOption() {
      this.form.options.push({
        name: '',
        value: [{ value: '', uid: Math.random() }],
        uid: Math.random()
      });
    },
    removeOptionItem(from, index) {
      from.splice(index, 1);
    },
    addOptionItem(value) {
      value.push({ value: '', uid: Math.random() });
    },
    buildOptionJson(data) {
      // const a = [{ name: '颜色', value: ['红', '黄'] }, { name: '', value: ['大'] }, { name: '尺码', value: ['S', 'M'] }];
      let result = [];
      const map = ['firstValue', 'secondValue', 'thirdValue'];

      data.forEach((option, index) => {
        if (!option.value.length) return;

        const name = option.name || map[index];

        if (!result.length) {
          result = option.value.map(v => {
            const x = {};
            x[name] = v.value;
            return x;
          });
        } else {
          const r = [];
          result.forEach(item => {
            option.value.forEach(v => {
              const x = { ...item };
              x[name] = v.value;
              r.push(x);
            });
          });
          result = r;
        }
      });

      const arr = this.form.optionsDetail;

      const rs = result.map((item, index) => {
        const { price = 0, discountprice = 0, vipprice = 0, groupprice = 0, quantity = 0, costprice = 0 } = arr[index] || {};
        return { ...item, price, discountprice, vipprice, groupprice, quantity, costprice };
      });

      return rs;
    }
  }
};
</script>

<style scoped>
.container {
  background-color: #fff;
  border-radius: 4px;
  padding: 15px;
  margin-top: 15px;
}
.container:first-child {
  margin: 0;
}
.line {
  text-align: center;
}
.tips {
  margin: 0;
  padding: 0;
  line-height: 1.4;
  padding-top: 4px;
  font-size: 12px;
  color: #aaa;
}
.tips.nopt {
  padding-top: 0;
}
.tips.bold {
  color: #333;
}
.title {
  padding: 0;
  margin: 0;
  color: #333;
  padding: 15px;
  padding-bottom: 30px;
}
.buttons {
  background-color: #f8f8f8;
  padding: 30px;
  position: fixed;
  bottom: 0;
  right: 0;
  left: 200px;
  display: flex;
  /* justify-content: flex-end; */
}
.options {
  min-height: 10px;
  width: 600px;
  border: 1px solid #efefef;
  padding: 10px;
  border-radius: 4px;
}
.options-title {
  font-size: 12px;
  color: #666;
}
.min-input .el-input__inner {
  height: 26px;
  line-height: 26px;
  padding: 0 4px;
}
.single {
  background-color: #f8f8f8;
}
.oi {
  padding: 5px 10px;
}
.double {
  padding-top: 15px;
  padding-bottom: 15px;
}
.options-detail {
  font-size: 12px;
  min-height: 10px;
  width: 800px;
  border: 1px solid #efefef;
  padding: 10px 15px;
  border-radius: 4px;
}
.options-table_header {
  border-bottom: 1px solid #efefef;
}
.othi {
  height: 38px;
  line-height: 38px;
}
.tips-title {
  color: #333;
}
.el-upload-list.el-upload-list--picture-card {
  margin-bottom: -20px;
}
.el-upload.el-upload--picture-card {
  margin-left: 10px !important;
}
</style>
<style>
.form-item-price .el-input-group__append {
  padding: 0 5px;
}

.pro-tag {
  padding: 3px 5px;
  border-radius: 3px;
  background-color: #f5efe8;
  color: #c09c4a;
  font-size: 10px;
  margin-left: 10px;
}
.pro-text {
  color: #c09c4a;
  font-size: 10px;
  margin-left: 5px;
}

.pro-triangle {
  color: #c09c4a;
  font-size: 10px;
  margin-left: 2px;
}
</style>
